export default __webpack_public_path__ + "static/media/searchImage.dbdf5d4a.svg";